<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="orderNo" placeholder="订单号"></el-input>
                        <el-select v-model="orderType" placeholder="订单类型">
                            <el-option label="建模订单" value="MODEL"> </el-option>
                            <el-option label="标准打印" value="PRINT"> </el-option>
                            <el-option label="定制化打印" value="CUSTOM"> </el-option>
                        </el-select>
                        <el-input v-model="contactName" placeholder="联系人"></el-input>
                        <el-input v-model="contactTel" placeholder="联系电话"></el-input>
                        <el-select v-model="status" placeholder="状态">
                            <el-option label="设计中" value="DESIGNING"> </el-option>
                            <el-option label="待确认" value="CONFIRM"> </el-option>
                            <el-option label="打印中" value="PRINTING"> </el-option>
                            <el-option label="后处理中" value="FINISHING"> </el-option>
                            <el-option label="待发货/待交付" value="DELIVERING"> </el-option>
                            <el-option label="待收货" value="TRANSPORT"> </el-option>
                            <el-option label="待验收" value="CHECKING"> </el-option>
                            <el-option label="已签收" value="SIGN"> </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" class="searchBtn" @click="exportExcel">导出</el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            :v-loading="loading"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="frontImageList"
                                label="设计图预览"
                                width="200"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                                <template slot-scope="scope">
                                    <img v-if="scope.row.frontImageList.length>0" :src="scope.row.frontImageList[0].fileUrl">
                                    <img v-else src="@/assets/images/defaultOrder.png">
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="orderNo"
                                label="订单号"
                                width="240"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>

                            <el-table-column
                                prop="orderTypeCn"
                                label="订单类型"
                                header-align="center"
                                show-overflow-tooltip
                                width="140"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="contactName"
                                align="center"
                                header-align="center"
                                label="联系人" width="100">
                            </el-table-column>

                            <el-table-column
                                prop="contactTel"
                                align="center"
                                header-align="center"
                                width="120"
                                label="联系电话">
                            </el-table-column>

                            <el-table-column
                                prop="statusCn"
                                align="center"
                                header-align="center"
                                label="状态" width="100">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                align="center"
                                header-align="center"
                                width="160"
                                label="创建时间">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="getDetail(scope.row.uuid,scope.row.expressCode,scope.row.expressName)">查看</el-button>
                                    <el-button type="text"  v-show="scope.row.status ==='PRINTING'" size="small" @click="printed(scope.row.uuid)">打印完成</el-button>
                                    <el-button type="text" v-show="scope.row.status ==='DELIVERING' && scope.row.orderType!=='MODEL'" size="small" @click="transport(scope.row.uuid)">填写物流信息</el-button>
                                    <el-button type="text" v-show="scope.row.status ==='DELIVERING' && scope.row.orderType=='MODEL'" size="small" @click="deliver(scope.row.uuid)">上传模型文件</el-button>
                                    <el-button type="text" v-show="scope.row.status ==='DESIGNING'" size="small" @click="confirmOrder(scope.row)">上传设计文件</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="物流信息"
            :visible.sync="transportDialog"
            width="600px">
            <!-- <div class="dialogContent" v-loading="loading"> -->
            <div class="dialogContent" >
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="物流单号" prop="expressCode" >
                        <el-input v-model="form.expressCode" style="width: 220px;" placeholder="请输入物流单号"></el-input>
                    </el-form-item>
                    <el-form-item label="物流公司" prop="expressName" >
                        <el-select v-model="form.expressName" placeholder="请选择物流公司">
                            <el-option
                                v-for="item in expressNameList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发货日期" prop="expressDate">
                        <el-date-picker
                            v-model="form.expressDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog
            title="模型文件"
            :visible.sync="deliverDialog"
            width="900px">
            <div class="dialogContent" v-loading="loading">
                <el-form :model="deliverForm" :rules="deliverRules" ref="deliverRefForm" label-width="100px">
                    <el-form-item label="上传模型" prop="deliverFileList">
                        <uploadFile
                            :buttonName="'上传模型'"
                            :fileList="deliverForm.deliverFileList"
                            :fileType="'obj,stl,OBJ,STL'"
                            :fileTypeMessage="'请上传类型为obj,stl的模型文件'"
                            :modelBtn="deliverUploadButton"
                            @deleteFile="deleteFile"
                            @getDragFile="getDragFile"
                        ></uploadFile>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submitDeliver">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog
            title="设计文件"
            :visible.sync="confirmOrderDialog"
            @close="closeDialog"
            width="900px">
            <div class="dialogContent dialogContentDesigne" v-loading="loading">
                <el-form :inline="true"  :model="confirmOrderForm" :rules="confirmOrderRules" ref="confirmOrderRuleForm" label-width="120px">
                    <div class="dialogContentBox">
                        <!--<el-form-item v-if="orderTypeConfirm !=='MODEL'" label="工艺" prop="craft" >
                            <el-input v-model="confirmOrderForm.craft" style="width: 220px;" placeholder="请输入工艺"></el-input>
                        </el-form-item>-->
                        <el-form-item v-if="orderTypeConfirm !=='MODEL'" label="模型尺寸(mm)" prop="size" >
                            <el-input  v-model="confirmOrderForm.size" style="width: 220px;" placeholder="请输入长度*宽度*高度"></el-input>
                        </el-form-item>
                    </div>
                    <div class="dialogContentBox">
                        <el-form-item v-if="orderTypeConfirm !=='MODEL'" label="重量(g)" prop="weight" >
                            <el-input-number v-model="confirmOrderForm.weight"  style="width: 220px;" placeholder="请输入重量(g)"></el-input-number>
                        </el-form-item>
                        <el-form-item v-if="orderTypeConfirm !=='MODEL'" label="交期日期" prop="deliveryDate">
                            <el-date-picker
                                v-model="confirmOrderForm.deliveryDate"
                                type="date"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>

                    </div>
                    <el-form-item label-width="120px" label="正面图片" prop="frontImageList">
                        <!-- <div style="display: flex;"> -->
                            <uploadImage
                                :buttonName="'正面图片'"
                                :img-file="confirmOrderForm.frontImageList"
                                :width="'224'"
                                :height="'143'"
                                @avatarChange="avatarChange($event,'zimg')"
                                @getDragImgFile="getDragImgFile($event,'zimg')"
                                @deleteImg="deleteImg($event,'zimg')"
                            ></uploadImage>
                        <!-- </div> -->
                    </el-form-item>
                    <el-form-item label="侧面图片" prop="sideImageList">
                        <div style="display: flex;">
                            <uploadImage
                                :buttonName="'侧面图片'"
                                :img-file="confirmOrderForm.sideImageList"
                                :width="'224'"
                                :height="'143'"
                                @avatarChange="avatarChange($event,'cdimg')"
                                @getDragImgFile="getDragImgFile($event,'cmg')"
                                @deleteImg="deleteImg($event,'cimg')"
                            ></uploadImage>
                        </div>
                    </el-form-item>
                    <el-form-item label="45°角度图片" label-width="120px" prop="quartersImageList">
                        <div style="display: flex;" class="confirmUpload">
                            <uploadImage
                                :buttonName="'45°角度图片'"
                                :img-file="confirmOrderForm.quartersImageList"
                                :width="'225'"
                                :height="'143'"
                                @avatarChange="avatarChange($event,'ximg')"
                                @getDragImgFile="getDragImgFile($event,'ximg')"
                                @deleteImg="deleteImg($event,'ximg')"
                            ></uploadImage>
                        </div>
                    </el-form-item>
                    <el-form-item label="上传视频" prop="videoUrl">
                        <uploadFile
                            :buttonName="'上传视频'"
                            :fileList="videoUrl"
                            :fileType="'mp4,video'"
                            :fileTypeMessage="'请上传mp4,video格式视频文件'"
                            @deleteFile="deleteVideoFile"
                            @getDragFile="getVideoDragFile"
                        ></uploadFile>
                    </el-form-item>
                  <!--  <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submitConfirmOrder">提交</el-button>
                    </el-form-item> -->
                </el-form>
                <div class="confirmOrder">
                    <el-button type="primary" @click="submitConfirmOrder">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog
            title="订单信息"
            :visible.sync="detailDialog"
            width="1000px" :close-on-click-modal="false">
            <div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="订单信息" name="first">
                        <div class="examine">
                            <div class="examineList examineListTwo">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">订单编号:</p>
                                    <p>{{ orderInfo.orderNo }}</p>
                                </div>
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">订单类型:</p>
                                    <p>{{ orderInfo.orderTypeCn }}</p>
                                </div>
                            </div>
<!--                            <div class="examineList examineListTwo">-->
<!--                                <div class="examineListTwo_box">-->
<!--                                    <p style="white-space:nowrap">材质类型:</p>-->
<!--                                    <p>{{ orderInfo.materialName }}</p>-->
<!--                                </div>-->
<!--                                <div class="examineListTwo_box">-->
<!--                                    <p style="white-space:nowrap">规格型号:</p>-->
<!--                                    <p>{{ orderInfo.specName }}</p>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="examineList examineListTwo">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">模型:</p>
                                    <p>{{ orderInfo.hasModelCn }}</p>
                                </div>
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">发票:</p>
                                    <p>{{ orderInfo.receiptCn }}</p>
                                </div>
                            </div>
                            <div class="examineList examineListTwo">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">是否上色:</p>
                                    <p>{{ orderInfo.finishingCn }}</p>
                                </div>
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">尺寸(mm):</p>
                                    <p>{{ orderInfo.longSize }}{{ orderInfo.wideSize!=null? '*':'' }}{{ orderInfo.wideSize }}{{ orderInfo.heightSize!=null? '*':'' }}{{ orderInfo.heightSize }}</p>
                                </div>
                            </div>
                            <div v-show="orderInfo.finishing === 'YES'" class="examineList examineListTwo">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">表面质感:</p>
                                    <p>{{ orderInfo.textureName }}</p>
                                </div>
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">颜色:</p>
                                    <p>{{ orderInfo.colorName }}</p>
                                </div>
                            </div>
                            <div v-show="orderInfo.orderType !== 'MODEL'" class="examineList examineListTwo">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">联系人:</p>
                                    <p>{{ orderInfo.contactName }}</p>
                                </div>
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">联系电话:</p>
                                    <p>{{ orderInfo.contactTel }}</p>
                                </div>
                            </div>
                            <div v-show="orderInfo.orderType !== 'MODEL'" class="examineList examineListTwo">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">联系地址:</p>
                                    <p>{{ orderInfo.fullAddress }}</p>
                                </div>
                            </div>
                            <div class="examineList examineListTwo">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">备注信息:</p>
                                    <p>{{ orderInfo.remark }}</p>
                                </div>
                            </div>
                            <div v-show="orderInfo.hasModel==='NO'" class="examineListImg">
                                <div class="examineListTwo_box examineListTwo_box2">
                                    <p style="white-space:nowrap">正面照:</p>
                                    <div class="examineListTwo_boxImgs">
                                        <img :src="item.fileUrl"  alt="" v-for="(item,index) in orderInfo.frontImageList" :key="index">
                                    </div>
                                </div>
                                <div class="examineListTwo_box examineListTwo_box2">
                                    <p style="white-space:nowrap">侧面照:</p>
                                    <div class="examineListTwo_boxImgs">
                                        <img :src="item.fileUrl" alt="" v-for="(item,index) in orderInfo.sideImageList" :key="index">
                                    </div>
                                </div>
                                <div class="examineListTwo_box examineListTwo_box2">
                                    <p style="white-space:nowrap">45°角度图片:</p>
                                    <div class="examineListTwo_boxImgs">
                                        <img :src="item.fileUrl"  alt="" v-for="(item,index) in orderInfo.quartersImageList" :key="index">
                                    </div>
                                </div>
                            </div>
                            <!-- <div v-show="orderInfo.hasModel==='NO'" class="examineList">
                                    <div class="examineListTwo_box">
                                        <p style="white-space:nowrap">侧面照:</p>
                                        <img :src="item.fileUrl" style="width: 224px;height: 143px;" alt="" v-for="(item,index) in orderInfo.sideImageList" :key="index">
                                    </div>
                                </div> -->
                            <!-- <div v-show="orderInfo.hasModel==='NO'" class="examineList">
                                    <div class="examineListTwo_box">
                                        <p style="white-space:nowrap">45°角度图片:</p>
                                        <img :src="item.fileUrl" style="width: 224px;height: 143px;" alt="" v-for="(item,index) in orderInfo.quartersImageList" :key="index">
                                    </div>
                                </div> -->
                            <div v-show="orderInfo.hasModel==='YES'" class="examineList">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">模型文件:</p>
                                    <el-button type="text" size="small" v-for="(item,index) in orderInfo.modelList" :key="index" @click="downloadFile(item.fileUrl)">{{item.fileName}}</el-button>
                                </div>
                            </div>
                            <!--<div v-show="orderInfo.finishing==='YES'" class="examineList">
                                <div class="examineListTwo_box">
                                    <p style="white-space:nowrap">45°上色效果:</p>
                                    <el-button type="text" size="small" v-for="(item,index) in orderInfo.textureFileList" :key="index" @click="downloadFile(item.fileUrl)">{{item.fileName}}</el-button>
                                </div>
                            </div>-->
                        </div>
                        <div class="examine2">
                            <h4>修改意见</h4>
                            <!-- <div class="examineListTwo_box examineListTwo_boxXiu" v-for="(item,index) in adviseList" :key="index"> -->
                            <div class="examineListTwo_boxXiu" v-for="(item,index) in adviseList" :key="index">
                                <p>{{ item.createTime }}</p>
                                <div v-for="(ite,indexq) in item.detailList" :key="indexq">
                                    <p>{{ ite.place }}:{{ ite.description }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="examine">
                            <h4>拒绝原因</h4>
                            <div class="examineList examineListTwo">
                                <div class="examineListTwo_box3" v-show="item.checkStatus=='NO'" v-for="(item,index) in deliverList" :key="index">
                                    <span>{{ item.createTime }}</span>
                                    <span>{{ item.refuseReason }}</span>
                                    <p style="width: 200px;" v-for="(fileInfo,index) in item.deliverFileList">
                                        文件名称：<a :href="fileInfo.fileUrl">{{fileInfo.fileName}}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="设计详情" name="second">
                        <div v-for="(item,index) in confirmOrderDetail" :key="index">
                             <div class="designDetails" style="font-weight: bold;font-size:16px">
                                    <p>设计文件上传时间：</p>
                                    <p>{{item.createTime.substring(0,10)}}</p>
                                </div>
                            <div class="designDetails">

                                <div class="designDetails_box">
                                    <p>尺寸（mm）：</p>
                                    <p>{{item.size}}</p>
                                </div>
                                <div class="designDetails_box">
                                    <p>重量（g）：</p>
                                    <p>{{item.weight}}</p>
                                </div>
                                <div class="designDetails_box">
                                    <p>交易日期：</p>
                                    <p>{{item.deliveryDate==null?item.deliveryDate:item.deliveryDate.substring(0,10)}}</p>
                                </div>
                            </div>
                            <div class="designDetails2">
                                <div class="designDetails_box">
                                    <p>正面图片：</p>
                                    <img :src="item.fileUrl"  alt="" v-for="(item,index) in item.frontImageList" :key="index">
                                </div>
                                <div class="designDetails_box">
                                    <p>侧面图片：</p>
                                    <img :src="item.fileUrl"  alt="" v-for="(item,index) in item.sideImageList" :key="index">
                                </div>
                                <div class="designDetails_box">
                                    <p>45角度图片：</p>
                                    <img :src="item.fileUrl"  alt="" v-for="(item,index) in item.quartersImageList" :key="index">
                                </div>
                                <div class="designDetails_box" v-if="item.videoUrl !=''">
                                    <p>视频上传：</p>
                                    <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsline="false" :options="playerOptions[index]"></video-player>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="物流信息" name="three">
                        <div class="logisticsInformation">
                            <h3>物流信息</h3>
                            <div class="logisticsContent">
                                <div class="logisticsLeft">
                                    <div class="orderItem" v-show="!logisticsTrackVisible">
                                        <p>物流公司：{{orderInfo.expressCompany }}</p>
                                        <p>物流单号：{{orderInfo.expressCode}}</p>
                                    </div>
                                    <div class="orderItem" v-show="logisticsTrackVisible">
                                        <div class="content">暂无物流信息</div>
                                    </div>
                                    <el-timeline v-show="!logisticsTrackVisible&&logisticsList.length>0">
                                        <el-timeline-item :class="index === 0?'timelineItemActive':''"
                                            :timestamp="item.ftime" :color="index === 0?'#1890FF':'#B2B2B2'"
                                            placement="top"
                                            v-for="(item,index) in logisticsList" :key="index"
                                        >
                                            <div class="timelineItemClass">
                                                <div class="content">{{item.context}}</div>
                                            </div>
                                            <el-button type="primary" size="mini" class="newest" v-if="index === 0">最新</el-button>

                                        </el-timeline-item>
                                    </el-timeline>
                                    <div class="orderItem" v-show="!logisticsTrackVisible&&logisticsList.length==0">
                                        <div class="content">{{ logisitcsResult }}({{ orderInfo.expressCode }}-{{ orderInfo.expressCompany }})</div>
                                    </div>
                                </div>
                                <div class="logisticsRight"></div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        appletQuerySx,
        finishedSx,
        getDictionaryItem,
        transportSx,
        deliverSx,
        confirmOrderSx,
        appletGetSx,
        listAdviseSx,
        listDeliverSx,
        findConfirmInfoSx, getLogisticsTrack, exportSxTable
    } from '../../utils/interface';
    import uploadFile from "@/components/uploadFile";
    import uploadImage from '@/components/uploadImage'
export default {
    components: {
        uploadFile,
        uploadImage
    },
    data() {
        return {
            activeName: 'first',
            playerOptions: [],
            orderNo:'',
            contactName:'',
            contactTel:'',
            status:'',
            orderType: '',
            tableData: [],
            current: 1,
            pageSize: 10,
            total: 0,
            loading:false,
            transportDialog:false,
            expressNameList:[],
            form: {
                expressCode: '',
                expressDate: '',
                expressName: ''
            },
            rules: {
                expressCode: [
                    {required: true, message: '请输入物流单号', trigger: 'blur'}
                ],
                expressDate: [
                    {required: true, message: '请选择日期',trigger: 'change'}
                ],
                expressName: [
                    {required: true, message: '请选择物流公司',trigger: 'change'}
                ],
            },
            uuid:'',
            deliverDialog:false,
            deliverForm:{deliverFileList:[]},
            deliverRules: {
                deliverFileList: [
                    {required: true, message: '请上传模型文件',trigger: 'change'}
                ],
            },
            deliverUploadButton:true,
            confirmOrderDialog:false,
            confirmOrderForm:{
                craft:'',
                size: '',
                weight: 0,
                deliveryDate:'',
                frontImageList:[],
                sideImageList:[],
                quartersImageList:[],
                videoUrl:'',
            },
            videoUrl:[],
            confirmOrderRules:{
                size: [
                    {required: true, message: '请输入模型尺寸',trigger: 'blur'}
                ],
                weight: [
                    {required: true, message: '请输入重量',trigger: 'blur'},
                ],
                deliveryDate: [
                    {required: true, message: '请选择交期日期',trigger: 'change'}
                ],
            },
            orderTypeConfirm:'',
            orderInfo:{},
            detailDialog:false,
            adviseList:[],
            deliverList:[],
            confirmOrderDetail:[],
            pickerOptions:{                                 //禁用当前日期之前的日期
                disabledDate(time) {
                    //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
                    return time.getTime() < Date.now() - 8.64e7;
                },
            },
            logisticsTrackVisible:true,
            logisticsList: [],
            logisitcsResult:'',
            logisticsUuid: '',
            logisticsNo: '',
            logisticsCompany:'',
            logisticsCompanyList: [
                {
                    value: 'yunda',
                    label: '韵达快递'
                },
                {
                    value: 'shunfeng',
                    label: '顺丰快递'
                },
                {
                    value: 'yuantong',
                    label: '圆通快递'
                },
                {
                    value: 'shentong',
                    label: '申通快递'
                },
                {
                    value: 'zhongtong',
                    label: '中通快递'
                }
            ],
        }
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120
            return {minHeight: height + 'px'}
        },
    },
    created() {
        this.getList();
        this.getDictionaryItem();
    },
    methods: {
        handleClick(){},
        getList(){
            let params = {
                orderNo:this.orderNo,
                contactName:this.contactName,
                contactTel:this.contactTel,
                orderType:this.orderType,
                status:this.status,
                current:this.current,
                pageSize:this.pageSize,
            }
            appletQuerySx(params).then((res)=>{
                this.tableData = res.data;
                this.total = res.total;
            });
        },
        getDictionaryItem() {
            getDictionaryItem({groupCode: "delivery_type"}).then((res) => {
                res.forEach((item, index) => {
                    this.expressNameList.push({name: item.name, id: item.code});
                });
            });
        },
        resetData(){
            this.orderNo = '';
            this.orderType = '';
            this.contactName='';
            this.contactTel='';
            this.status='';
            this.current = 1;
            this.getList();
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getList();
        },
        search(){
           this.current = 1;
           this.getList();
        },

        init(){
            this.orderNo = '';
            this.contactName='';
            this.contactTel='';
            this.status='';
            this.orderType = '';
            this.current = 1;
            this.getList()
        },
        printed(uuid){
            this.$confirm('请确认打印完成?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                finishedSx(uuid).then((res)=>{
                    if(res.success){
                        this.$message({
                            type: 'success',
                            message: '打印完成!'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            type: 'waring',
                            message: res.message
                        });
                    }
                })
            }).catch(() => {})
        },
        getDetail(uuid,expressCode,expressName){
            appletGetSx(uuid).then((res)=>{
                this.orderInfo = res;
            });
            listAdviseSx(uuid).then((res)=>{
                this.adviseList = res;
            });
            listDeliverSx(uuid).then((res)=>{
                this.deliverList = res;
            });
            findConfirmInfoSx({orderUuid:uuid}).then((res)=>{
                this.confirmOrderDetail =res;
                this.playerOptions = []
                res.forEach((item,index)=>{
                    if(item.videoUrl) {
                        let playerOptionsVideo = {
                            autoplay: true,
                            muted: true,
                            loop: true,
                            preload: 'auto',
                            language: 'zh-CN',
                            aspectRatio: '16:9',
                            fluid: true,
                            sources: [{
                                type: "video/mp4",
                                src: item.videoUrl
                            }],
                            poster: "",
                            notSupportedMessage: '此视频暂无法播放，请稍后再试',
                            controlBar: {
                                timeDivider: false,
                                durationDisplay: false,
                                remainingTimeDisplay: false,
                                fullscreenToggle: false  //全屏按钮
                            },
                        }
                        this.playerOptions.push(playerOptionsVideo)
                        // this.playerOptions.sources[0].src = item.videoUrl;
                    }
                })
            });
            //物流信息
            if(expressCode!=null) {
                this.viewLogisticsInfo('',expressCode,expressName);
            }
            this.detailDialog = true;
        },
        // 查看实时物流
        viewLogisticsInfo(uuid,logisticsNo,logisticsUuid){

            this.logisticsList=[]
            this.logisticsUuid=''
            this.logisticsNo= ''
            this.logisticsCompany=''

            let params = {
                uuid:uuid,
                logisticsNo:logisticsNo,
                logisticsUuid:logisticsUuid
            };
            getLogisticsTrack(params).then((res)=>{
                if(res.success){
                    if(res.data.status === '200'){
                        //接口查询成功
                        this.logisticsTrackVisible = false;
                        this.logisticsNo = res.data.nu;
                        this.logisticsCompany = this.logisticsCompanyList.find(i => i.code === res.data.com);
                        this.logisticsList = res.data.data;
                    }else{
                        this.logisticsTrackVisible = false;
                        this.logisitcsResult = res.data.message;
                        this.$message({
                            type: 'warning',
                            message: res.data.message
                        })
                    }
                }else{
                    this.logisticsTrackVisible = true
                }
            });

        },
        transport(uuid){
            this.uuid = uuid;
            this.transportDialog = true
        },
        submit(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    transportSx(this.uuid,this.form).then((res)=>{
                        this.$message.success('保存成功！')
                        this.loading = false
                        this.transportDialog = false
                        this.getList();
                    })
                } else {
                    return false;
                }
            });
        },
        deliver(uuid){
            this.deliverForm.deliverFileList =[]
            this.uuid = uuid;
            this.deliverDialog = true
        },
        // 删除模型文件
        deleteFile(file){
            this.deliverForm.deliverFileList = file
            this.deliverUploadButton = true
        },
        // 上传模型文件
        getDragFile(file){
            this.deliverForm.deliverFileList = file
            this.deliverUploadButton = false;
        },
        submitDeliver(){
            this.$refs.deliverRefForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    let fileList =[];
                    this.deliverForm.deliverFileList.forEach((item)=>{
                        fileList.push({fileName:item.name,fileUrl:item.url})
                    })
                    this.deliverForm.deliverFileList = fileList;
                    deliverSx(this.uuid,this.deliverForm).then((res)=>{
                        this.$message.success('保存成功！')
                        this.loading = false
                        this.deliverDialog = false
                        this.getList();
                    })
                } else {
                    return false;
                }
            });
        },
        confirmOrder(item){
            this.videoUrl=[];
            this.uuid = item.uuid;
            this.orderTypeConfirm = item.orderType;
            this.confirmOrderForm.craft = item.materialName;
            this.confirmOrderForm.size = item.size
            this.confirmOrderDialog = true
        },
        submitConfirmOrder(){
            this.$refs.confirmOrderRuleForm.validate((valid) => {
                if (valid) {
                    if (this.confirmOrderForm.frontImageList.length < 1) {
                        this.$message.error('请上传至少1张正面图片!');
                        return false;
                    }
                    if (this.confirmOrderForm.sideImageList.length < 1) {
                        this.$message.error('请上传至少1张侧面图片!');
                        return false;
                    }
                    if (this.confirmOrderForm.quartersImageList.length < 1) {
                        this.$message.error('请上传至少1张45°角度图片!');
                        return false;
                    }
                    if (this.videoUrl.length > 1) {
                        this.$message.error('最多上传一个视频!');
                        return false;
                    }
                    let frontImageList = [];
                    this.confirmOrderForm.frontImageList.forEach((item)=>{
                        frontImageList.push({fileUrl:item.url});
                    })
                    this.confirmOrderForm.frontImageList = frontImageList;

                    let sideImageList = [];
                    this.confirmOrderForm.sideImageList.forEach((item)=>{
                        sideImageList.push({fileUrl:item.url});
                    })
                    this.confirmOrderForm.sideImageList = sideImageList;

                    let quartersImageList = [];
                    this.confirmOrderForm.quartersImageList.forEach((item)=>{
                        quartersImageList.push({fileUrl:item.url});
                    })
                    this.confirmOrderForm.quartersImageList = quartersImageList;

                    let videoUrlList='';
                    this.videoUrl.forEach((item)=>{
                        videoUrlList= item.url;
                    })
                    this.confirmOrderForm.videoUrl = videoUrlList;

                    this.loading = true
                    confirmOrderSx(this.uuid,this.confirmOrderForm).then((res)=>{
                        this.$message.success('保存成功！')
                        this.loading = false
                        this.confirmOrderDialog = false
                        this.getList();
                    })
                    this.loading = false
                } else {
                    return false;
                }
            });
        },
        // 上传成功
        avatarChange(val,type) {
            if(type == 'zimg'){console.log("=====1======"+val+"--------------"+type)
                this.confirmOrderForm.frontImageList = val
                this.$refs.confirmOrderRuleForm.validateField('frontImageList')
            }else if (type == 'cimg'){console.log("=======2===="+val+"--------------"+type)
                this.confirmOrderForm.sideImageList = val
                this.$refs.confirmOrderRuleForm.validateField('sideImageList')
            }else if (type == 'ximg'){console.log("=======2===="+val+"--------------"+type)
                this.confirmOrderForm.quartersImageList = val
                this.$refs.confirmOrderRuleForm.validateField('quartersImageList')
            }
        },
        // 删除图片
        deleteImg(val,type) {
            if(type == 'zimg'){
                this.confirmOrderForm.frontImageList = val
                this.$refs.confirmOrderRuleForm.validateField('frontImageList')
            }else if (type == 'cimg'){
                this.confirmOrderForm.sideImageList = val
                this.$refs.confirmOrderRuleForm.validateField('sideImageList')
            }else if (type == 'ximg'){
                this.confirmOrderForm.quartersImageList = val
                this.$refs.confirmOrderRuleForm.validateField('quartersImageList')
            }
        },
        // 获取拖拽后的图片
        getDragImgFile(val,type) {
            if(type == 'zimg'){
                this.confirmOrderForm.frontImageList = val
                this.$refs.confirmOrderRuleForm.validateField('frontImageList')
            }else if (type == 'cimg'){
                this.confirmOrderForm.sideImageList = val
                this.$refs.confirmOrderRuleForm.validateField('sideImageList')
            }else if (type == 'ximg'){
                this.confirmOrderForm.quartersImageList = val
                this.$refs.confirmOrderRuleForm.validateField('quartersImageList')
            }
        },
        closeDialog(){
            this.$refs.confirmOrderRuleForm.resetFields();
            this.videoUrl=[];
        },
        deleteVideoFile(file){
            this.videoUrl = file;
        },
        getVideoDragFile(file){
            this.videoUrl = file;
        },
        downloadFile(fileUrl){
            let a = document.createElement('a');
            a.href = fileUrl;
            a.click();
        },
        exportExcel(){
            this.$confirm('是否导出数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                let params = {
                    orderNo:this.orderNo,
                    contactName:this.contactName,
                    contactTel:this.contactTel,
                    orderType:this.orderType,
                    status:this.status,
                }
                exportSxTable(params).then((res)=>{
                    // 文件下载
                    const fileNames = res.headers['content-disposition']
                    if (fileNames) {
                        // 解码
                        const fileName = decodeURIComponent(fileNames.match(/=(.*)$/)[1])
                        // 处理返回的文件流
                        const content = res.data
                        const blob = new Blob([content], {type: 'application/octet-stream; charset=utf-8'})
                        if ('download' in document.createElement('a')) {
                            // 非IE下载
                            const a = document.createElement('a')
                            a.download = '订单列表.xls'
                            a.style.display = 'none'
                            a.href = URL.createObjectURL(blob)
                            document.body.appendChild(a)
                            a.click()
                            URL.revokeObjectURL(a.href) // 释放URL 对象
                            document.body.removeChild(a)
                        } else {
                            // IE10+下载
                            navigator.msSaveBlob(blob, '订单列表.xls')
                        }
                    }
                    this.$message.success('导出成功');

                }).catch(function (error) {
                    console.log(error);
                });
            }).catch(() => {})

        },
    }
}
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .examine {
        h2 {
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 26px;
            letter-spacing: 1px;
        }

        .examineListImg {
            img {
                width: 183px;
                height: 103px;
                margin-right: 10px;
                margin-top: 10px;
            }
            p:nth-of-type(1){
                margin-right: 16px;
                width: 78px;
                flex-shrink: 0;
            }
            .examine_html {
                width: 90%;
                /deep/pre {
                    white-space: pre-line !important;
                }
                /deep/img {
                    max-width: 100%;
                }
            }
            .examineListTwo_box{
                 display: flex;
            }
            .examineListTwo_boxImgs {
                display: flex;
                flex-wrap: wrap;
            }
        }
        .examineList {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            img {
                width: 300px;
                height: 300px;
            }
            p:nth-of-type(1){
                margin-right: 16px;
                width: 65px;
                flex-shrink: 0;
            }
            .examine_html {
                width: 90%;
                /deep/pre {
                    white-space: pre-line !important;
                }
                /deep/img {
                    max-width: 100%;
                }
            }
            .examineListTwo_box{
                 width: 50%;
            }
        }
        .examineListTwo {
            display: flex;
            align-items: center;
            .examineListTwo_box {
                display: flex;
                align-items: center;
                width: 50%;
            }
        }

    }
    /deep/.el-dialog__body{
        padding: 30px 30px;
    }
    .confirmOrder{
        width: 300px;
        margin: auto;
        /deep/.el-button{
            width: 250px;
        }
    }
    .confirmUpload{
       /deep/.el-button{
          padding: 12px 14px;
       }
    }
    .dialogContentDesigne {
        /deep/.el-form--inline .el-form-item {
            display: flex;
        }
        /deep/.el-form-item__label {
            flex-shrink: 0;
        }
        .dialogContentBox {
            display: flex;
            align-items: center;
        }
    }
    .examine2 {
        h2 {
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 26px;
            letter-spacing: 1px;
        }
        .examineListTwo_boxXiu {
            display: flex;
            align-items: center;
            p {
                margin-right: 15px;
            }
        }
    }
.designDetails {
    display: flex;
    flex-wrap: wrap;
    .designDetails_box {
        display: flex;
        width: 33%;
        margin-bottom: 15px;
        img {
            width: 200px;
            height: 150px;
        }
    }
}
.designDetails2 {
    // display: flex;
    // flex-wrap: wrap;
    margin-bottom: 15px;
    .designDetails_box {
        // width: 50%;
        img {
            width: 200px;
            height: 150px;
            margin-right: 15px;
        }
        .video-player {
            width: 300px;
        }
    }
}
.timelineItemActive {
    /deep/.el-timeline-item__timestamp {
        color: #108ee9 !important;
    }
    /deep/.el-timeline-item__content {
        color: #108ee9 !important;
    }
}
/deep/.el-timeline-item__wrapper {
    padding-left: 88px !important;
    position: relative
}
.logisticsLeft {
    .newest {
        position: absolute;
        top: 0;
        left: 24px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/appletSx/appletOrderList.vue